<template>
	<section class="blocks" id="blocks2" :style="{ background: bg_color }">
		<div class="container">
			<article>

				<div class="left-block">
					<h2 class="title-box left">{{ title }}</h2>
					<div class="content-bloco2" v-html="content">
						{{ content }}
					</div>
				</div>

				<figure class="desktop">
					<img :src="figure" :alt="title">
				</figure>

				<figure class="mobile">
					<img :src="resp_image" :alt="title">
				</figure>
			</article>

		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color", "resp_image"]
    }
</script>

<style lang="scss">
	#blocks2 {

		article {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;

			h2 {
				margin-bottom: 80px;
			}

			.left-block {
				flex-basis: 50%;
				margin-top: 10px;

				p {
					width: 90%;
				}
			}

			figure {
				flex-basis: 50%;
				padding: 0;
				text-align: center;
			}

			p {
				color: #222831;
				font-size: 1.6em;
				line-height: 24px;
				margin-bottom: 25px;
				text-align: left;
			}
		}
	}

	@media (max-width: 767px) {
		#blocks2 {
			flex-wrap: wrap;

			article {
				flex-wrap: wrap;

				.left-block {
					flex-basis: 100%;

					p {
						width: 100%;
					}
				}

				figure {
					flex-basis: 100%;
					margin-top: 20px;

					img {
						width: 90%
					}
				}
			}
		}
	}

	@media (max-width: 640px) {
		#blocks2 {
			flex-wrap: wrap;

			article {
				flex-wrap: wrap;

				.left-block {
					flex-basis: 100%;

					p {
						width: 100%;
					}
				}

				figure {
					flex-basis: 100%;
					margin-top: 20px;

					img {
						width: 90%
					}
				}
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/shared/blocks/Block2.vue